import {Component, DestroyRef, inject, OnInit} from "@angular/core";
import {
  Aangifte,
  AangifteRapport,
  BokkzIbDataService,
  IbRekenService,
  IncomeTaxEntity,
} from '@snelstart-ventures/fiscaal/domain-logic';
import {filter, map, Observable, shareReplay, switchMap, take} from 'rxjs';
import {KostenExtraGezinshulpComponent} from './kosten-extra-gezinshulp/kosten-extra-gezinshulp.component';
import {BehandelkostenComponent} from './behandelkosten/behandelkosten.component';
import {MedicijnenComponent} from './medicijnen/medicijnen.component';
import {HulpmiddelenComponent} from './hulpmiddelen/hulpmiddelen.component';
import {ReiskostenEigenZorgComponent} from './reiskosten-eigen-zorg/reiskosten-eigen-zorg.component';
import {DietenComponent} from './dieten/dieten.component';
import {ReiskostenZorgGezinslidComponent} from './reiskosten-zorg-gezinslid/reiskosten-zorg-gezinslid.component';
import {
  ExtraUitgavenKledingEnBeddengoedComponent
} from './extra-uitgaven-kleding-en-beddengoed/extra-uitgaven-kleding-en-beddengoed.component';
import {CommonModule} from '@angular/common';
import {SharedUiButtonModule} from '@snelstart/ui-button';
import {SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {SharedUiAlertModule} from '@snelstart/ui-alert';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';


@Component({
    selector: 'snelstart-venture-fiscaal-feature-pga-specifieke-zorgkosten',
    templateUrl: './pga-specifieke-zorgkosten.component.html',
    styleUrls: ['./pga-specifieke-zorgkosten.component.scss'],
    imports: [
        KostenExtraGezinshulpComponent,
        BehandelkostenComponent,
        MedicijnenComponent,
        HulpmiddelenComponent,
        ReiskostenEigenZorgComponent,
        DietenComponent,
        ReiskostenZorgGezinslidComponent,
        ExtraUitgavenKledingEnBeddengoedComponent,
        CommonModule,
        SharedUiButtonModule,
        SharedUiFormControlsModule,
        SharedUiAlertModule,
    ],
})
export class PgaSpecifiekeZorgkostenComponent implements OnInit {
    private dataService = inject(BokkzIbDataService);
    private apiService= inject(IbRekenService);

    private destroyRef = inject(DestroyRef);
    readonly incomeTaxEntity$: Observable<IncomeTaxEntity> = this.dataService.incomeTaxEntity$.pipe(
        filter((data): data is IncomeTaxEntity => !!data?.sstRelationId),
        takeUntilDestroyed(this.destroyRef),
        shareReplay({ bufferSize: 1, refCount: true }),
    );

    readonly aangifteRapport$: Observable<AangifteRapport> = this.incomeTaxEntity$.pipe(
        take(1),
        takeUntilDestroyed(this.destroyRef),
        map((entity) => entity.aangifte),
        filter(
            (aangifte): aangifte is Aangifte =>
                !!aangifte &&
                !!aangifte.aangever &&
                aangifte.aangever.burgerlijkeStaat != null &&
                aangifte.aangever.geboortedatum != null &&
                aangifte.aangifteJaar != null,
        ),
        switchMap((aangifte) => this.apiService.getIncomeTaxReport(aangifte)),
        filter((rapport): rapport is AangifteRapport => !!rapport?.specificatieGiften),
        shareReplay({ bufferSize: 1, refCount: true }),
    );

    ngOnInit() {
        this.incomeTaxEntity$.pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe();
    }
}
